import type { SVGProps } from 'react';
const DawnFlagPK = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-PK_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-PK_svg__a)">
      <path fill="#0A632F" d="M22 0H6.286v16H22z" />
      <path
        fill="#fff"
        d="M18.598 8.6c-.101 1-.52 1.962-1.26 2.716-1.765 1.797-4.688 1.734-6.529-.14-1.84-1.875-1.903-4.852-.138-6.648a4.35 4.35 0 0 1 2.667-1.283c-.31.186-.603.415-.87.687-1.604 1.634-1.684 4.2-.177 5.735 1.506 1.533 4.028 1.453 5.632-.18q.4-.411.675-.887m-2.026-2.116-.25 1.518-.698-1.365-1.496.227 1.06-1.099-.675-1.378 1.354.687 1.079-1.08-.223 1.524 1.341.711z"
      />
    </g>
  </svg>
);
export default DawnFlagPK;
